export const SELLER_INVOICES_PAGE = 'seller-invoices-page';
